"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FilePickerViewSwitcher_1 = require("../types/FilePickerViewSwitcher");
var owa_fileprovider_store_1 = require("owa-fileprovider-store");
var satcheljs_1 = require("satcheljs");
var filePickerStoreData = {
    viewState: {
        isOpen: false,
        fileSelectionFilter: owa_fileprovider_store_1.FileSelectionFilter.None,
        selectedFileProvider: null,
        selectedProviderScope: null,
        filePickerViewState: {
            breadcrumbs: [],
            columnSorting: null,
            fileProviderItems: [],
            isLoadingItems: false,
            pagingMetadata: null,
            selectedFileProviderItems: [],
            selectedFolder: null,
            selectedView: null,
            supportedActions: [],
            supportedActionsMessages: [],
            supportedViews: [],
            totalItemsCount: 0,
            userPreferredViewType: FilePickerViewSwitcher_1.FilePickerViewType.List,
            searchViewState: {
                searchQuery: '',
                isInSearchMode: false,
            },
            filterOptionsState: {
                showFilterOptions: false,
                selectedFilterOption: 0 /* None */,
            },
        },
        fileProviderPaneViewState: {
            fileProvidersToDisplay: [],
        },
        filePickerErrorMessageViewState: {
            isShown: false,
            message: null,
        },
        filePickerActionsViewState: {
            isOpen: false,
            saveUserChoice: false,
            isCalloutVisible: false,
            uploadFolderName: null,
        },
    },
};
var filePickerStore = satcheljs_1.createStore('filepicker', filePickerStoreData)();
exports.default = filePickerStore;
//# sourceMappingURL=filePickerStore.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/attachments/owa-filepicker-store/lib/store/filePickerStore.js
// module id = 1779
// module chunks = 2 3 43 106 107